<template>
    <syain-detail />
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import SyainDetail from '@/components/syain/Detail.vue'

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'syain-detail': SyainDetail
    }
})
</script>
